import './resourceHome.css';
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { PROD } from '../../../common/constants';
import { Typography } from '@mui/material'

function ResourceAdminHome() {

  const navigate = useNavigate()
  const onSubmit = (e) => {
    navigate("/selectStakeHolder");

  }
  function viewAllWorklist(e, type) {
    e.preventDefault();
    navigate("/allWorkList", { state: { type: type } });
  }
  function viewAllMappedUser(e) {
    e.preventDefault();
    navigate("/viewAllMappingRoutes");
  }
  function viewTransMappedUser(e) {
    e.preventDefault();
    navigate("/viewTransporterMappingRoutes");
  }
  function mappingStakeholderTransporter(e) {
    e.preventDefault();
    navigate("/selectTransporterStakeholder");
  }
  function mappingGrowerHitProceed(e) {
    e.preventDefault();
    navigate("/growerHitMapping");
  }
  return (
    <div className="RescHomePage">
      <Typography variant="h5" gutterBottom>Welcome!</Typography>
    </div>
  );
}

export default ResourceAdminHome;
